interface Serializable {
	toString(): string;
	toJSON?: () => any;
}

export const serializeRecord = <T extends Serializable>(record: T) => {
	const data = { id: record.toString() };

	if (record.toJSON) {
		Object.assign(data, { record: record.toJSON() });
	}

	return data;
};
